<div class="spinner-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>
<div class="bouds-div" *ngIf="!loading">
    <form [formGroup]="group" class="w100" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index"
                    [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span>{{control.get('name').value}}</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <mat-icon fontSet="material-icons-outlined">menu_book</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="div-wrap">
                            <div class="w100">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'type'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.TYPE'"></smt-search-select>
                            </div>

                            <div class="w100" *ngIf="control.get('subtype').value">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'subtype'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SUBTYPE'"></smt-search-select>
                            </div>

                            <div class="w100" *ngIf="control.get('primaryApprovingBody').value">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'primaryApprovingBody'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PRIMARY_APPROVING_BODY'"></smt-search-select>
                            </div>

                            <div class="w100" *ngIf="control.get('secondaryApprovingBody').value">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'secondaryApprovingBody'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY'" [multiple]="true"></smt-search-select>
                            </div>

                            <div class="w100" *ngIf="control.get('secondaryApprovingBodySub').value">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'secondaryApprovingBodySub'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY_SUB'" [multiple]="true"></smt-search-select>
                            </div>

                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PROVISION_NUMBER' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="provisionNumber"></textarea>
                            </mat-form-field>

                            <div class="w45">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'actionType'"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.ACTION_TYPE'"></smt-search-select>
                            </div>

                            <div class="w45" *ngIf="control.get('approvalDate').value">
                                <smt-date-input [group]="formArrayGroup(i)" [controlName]="'approvalDate'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.APPROVAL_DATE'"></smt-date-input>
                            </div>

                            <div class="w45" *ngIf="control.get('effectiveDate').value">
                                <smt-date-input [group]="formArrayGroup(i)" [controlName]="'effectiveDate'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.EFFECTIVE_DATE'"></smt-date-input>
                            </div>
                        </div>

                        <div class="action-buttons">
                            <button mat-raised-button color="primary"
                                (click)="viewBoudElement(control.get('id').value)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS.VIEW_ITEM' | translate">
                                <mat-icon>visibility</mat-icon> {{ 'APP.ACTIONS.VIEW' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>
</div>